import { getVm } from '@/helpers/vm-helper';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { SnowplowContext, TrackingProviderPropertiesInterface } from '@/helpers/tracking/providers';

import { getLastProView } from '@/helpers/pro-web-helper';

let mCtr: any = null;

export const ModalHelper = {
	getCtr: async () => {
		if (!mCtr) {
			const { modalController } = await import('@/ionic.loader');
			mCtr = modalController;
			return mCtr;
		}
		return mCtr;
	},

	openModal: async (
		component: any,
		componentProps = {},
		options = {},
		location = '', // For tracking.
		customModalOpenEvent = false,
		additinalContexts: SnowplowContext[] = [],
		onCloseCallback?: Function
	) => {
		await ModalHelper.getCtr();

		const opts = {
			component,
			componentProps: { parent: getVm(), propsData: { ...componentProps, location } },
			...options,
		};

		const modal = await mCtr.create(opts);
		await modal.present();

		let componentName = component?.extendOptions?.name;

		if (!componentName) {
			componentName = (await component())?.default?.extendOptions?.name;
		}

		const trackingInfo: TrackingProviderPropertiesInterface = { action: 'modal_opened' };

		switch (componentName) {
			case 'AccountModal':
				if (location !== '') trackingInfo.property = location;
			case 'SettingsModal':
				trackingInfo.label = 'user_account';
				break;
			case 'MarkAsSeenModal':
				trackingInfo.label = 'tv_show_tracking';
				break;
			case 'MarkAsSeenModalGraphql':
				trackingInfo.label = 'tv_show_tracking';
				break;
			case 'CancelProModal':
				if (location !== '') trackingInfo.property = location;
				trackingInfo.label = 'FreemiumCancellationModal';
				break;
			default:
				trackingInfo.label = componentName;
				break;
		}

		const contexts: SnowplowContext[] = getVm().$store.getters['titleDetails/refferalModuleContext']
			? [getVm().$store.getters['titleDetails/refferalModuleContext']]
			: [];

		if (!customModalOpenEvent) {
			TrackingHelper.trackEvent('userinteraction', trackingInfo, contexts.concat(additinalContexts));
		}

		const modalData = await modal.onDidDismiss();

		if (onCloseCallback) {
			onCloseCallback();
		}

		if (!customModalOpenEvent) {
			TrackingHelper.trackEvent(
				'userinteraction',
				{
					action: 'modal_closed',
					label: trackingInfo.label,
					property:
						componentName === 'ProModal'
							? getLastProView() || undefined
							: componentName === 'CancelProModal'
							? 'SettingsProSubscription'
							: undefined,
				},
				contexts.concat(additinalContexts)
			);
		}

		return modalData.data;
	},

	close: (id?: string): Promise<boolean> => {
		return mCtr?.dismiss({}, '', id);
	},
};
